// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"0110f8b7","594":"e1c0d932","766":"b3803052","970":"9d7e2953"}[chunkId] + ".chunk.js";
};